// extracted by mini-css-extract-plugin
export default {"carouselWrapper":"vI-z"};